(() => {
  const root = window.Shopify?.routes?.root || '/';
  const dialog = document.getElementById('SykCartDialog');
  let cartBusy = false;
  let focusBeforeCart;
  const cartStatus = text => { const el = dialog?.querySelector('[data-cart-status]'); if (el) el.textContent = text; };
  const applyCart = (cart, html) => {
    if (!html) throw new Error('Your bag was updated. Open the full bag to review it.');
    dialog.querySelector('[data-cart-render]').innerHTML = html;
    window.Shopify?.PaymentButton?.init?.();
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = `(${cart.item_count})`; el.closest('a')?.setAttribute('aria-label', `Cart, ${cart.item_count} items`); });
    document.dispatchEvent(new CustomEvent('syokami:cart-updated', {detail: {itemCount: cart.item_count}}));
  };
  const refreshCart = async () => {
    const [cartResponse, sectionResponse] = await Promise.all([
      fetch(root + 'cart.js', {headers: {'Accept': 'application/json'}}),
      fetch(root + 'cart?sections=syk-cart-panel')
    ]);
    if (!cartResponse.ok || !sectionResponse.ok) throw new Error('We could not refresh your bag. Please open the full bag.');
    const cart = await cartResponse.json();
    const sections = await sectionResponse.json();
    applyCart(cart, sections['syk-cart-panel']);
    return cart;
  };
  const openCart = async ({refresh = true, returnFocus} = {}) => {
    if (!dialog || typeof dialog.showModal !== 'function') { window.location.assign(root + 'cart'); return; }
    focusBeforeCart = returnFocus || document.activeElement;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('syk-dialog-open');
    dialog.querySelector('[data-cart-close]')?.focus();
    if (refresh || !dialog.dataset.loaded) {
      cartStatus('Loading your bag…');
      dialog.setAttribute('aria-busy', 'true');
      dialog.querySelector('[data-cart-render]')?.setAttribute('inert', '');
      try {
        await refreshCart();
        dialog.dataset.loaded = 'true';
        cartStatus('');
      } finally {
        dialog.removeAttribute('aria-busy');
        dialog.querySelector('[data-cart-render]')?.removeAttribute('inert');
      }
    }
  };
  window.SykCommerce = {openCart, refreshCart};
  if (dialog) {
    const closed = () => { document.documentElement.classList.remove('syk-dialog-open'); focusBeforeCart?.focus(); };
    dialog.addEventListener('close', closed);
    dialog.querySelector('[data-cart-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    let quantityTimer;
    dialog.addEventListener('input', event => {
      const input = event.target.closest('[data-cart-quantity]');
      if (!input) return;
      clearTimeout(quantityTimer);
      quantityTimer = setTimeout(() => {
        const quantity = Number(input.value);
        if (input.value !== '' && Number.isInteger(quantity) && quantity >= 0) changeLine(input.dataset.lineKey, quantity);
      }, 400);
    });
    dialog.addEventListener('change', async event => {
      const input = event.target.closest('[data-cart-quantity]');
      clearTimeout(quantityTimer);
      if (input) {
        const quantity = Number(input.value);
        if (!Number.isInteger(quantity) || quantity < 0) input.value = input.dataset.startQuantity;
        await changeLine(input.dataset.lineKey, quantity);
      }
    });
    dialog.addEventListener('click', async event => {
      const button = event.target.closest('[data-cart-remove]');
      if (button) await changeLine(button.dataset.lineKey, 0);
    });
    async function changeLine(key, quantity) {
      if (cartBusy) return;
      if (!Number.isInteger(quantity) || quantity < 0) { cartStatus('Enter a whole-number quantity of zero or more.'); return; }
      cartBusy = true;
      dialog.setAttribute('aria-busy', 'true');
      dialog.querySelectorAll('[data-cart-quantity], [data-cart-remove], [name=checkout]').forEach(el => {el.disabled = true;});
      cartStatus('Updating your bag…');
      let committed = false;
      try {
        const response = await fetch(root + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to update this item.');
        committed = true;
        await refreshCart();
        cartStatus(quantity ? 'Quantity updated.' : 'Item removed.');
        const changed = [...dialog.querySelectorAll('[data-cart-quantity]')].find(el=>el.dataset.lineKey===key);
        (changed || dialog.querySelector('[data-cart-close]'))?.focus();
      } catch (error) {
        if (committed) { window.location.assign(root + 'cart'); return; }
        cartStatus(error.message || 'Unable to update your bag. Please try again.');
        dialog.querySelectorAll('[data-cart-quantity]').forEach(el => {el.value = el.dataset.startQuantity;});
        dialog.querySelectorAll('[data-cart-quantity], [data-cart-remove], [name=checkout]').forEach(el => {el.disabled = false;});
      } finally { cartBusy = false; dialog.removeAttribute('aria-busy'); }
    }
    document.querySelectorAll('.syk-cart-link').forEach(link => link.addEventListener('click', async event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      try { await openCart(); } catch { window.location.assign(link.href); }
    }));
  }

  function initialize(scope = document) {
    scope.querySelectorAll('[data-local-filter-controls]').forEach(controls => {
      if (controls.dataset.ready) return; controls.dataset.ready = 'true'; controls.hidden = false;
      const section = controls.closest('section');
      const cards = [...section.querySelectorAll('[data-filter-item]')];
      const use = controls.querySelector('[data-use-filter]'); const storage = controls.querySelector('[data-storage-filter]');
      const update = () => {
        let count = 0;
        cards.forEach(card => {const visible = (!use?.value || card.dataset.use === use.value) && (!storage?.value || card.dataset.storage === storage.value); card.hidden = !visible; if (visible) count++;});
        controls.querySelector('[data-local-filter-count]').textContent = `${count} of ${cards.length} products in this view`;
        section.querySelector('[data-local-filter-empty]').hidden = count > 0;
      };
      use?.addEventListener('change',update); storage?.addEventListener('change',update); update();
    });
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      const picker = section.querySelector('[data-option-picker]');
      const select = section.querySelector('[data-variant-select]');
      if (!picker || !select || picker.dataset.ready) return;
      picker.dataset.ready = 'true'; picker.hidden = false; select.hidden = true;
      const oldLabel = section.querySelector(`label[for="${select.id}"]`); if (oldLabel) oldLabel.hidden = true;
      picker.addEventListener('change', event => {
        if (!event.target.matches('input[type=radio]')) return;
        select.value = event.target.value; select.dispatchEvent(new Event('change', {bubbles:true}));
      });
      select.addEventListener('change', () => picker.querySelectorAll('input').forEach(input => {input.checked = input.value === select.value;}));
    });

    scope.querySelectorAll('[data-search-input]').forEach(input => {
      if (input.dataset.ready) return; input.dataset.ready = 'true';
      const form = input.closest('form'); const panel = form.querySelector('[data-search-suggestions]');
      if (!panel) return;
      let timer; let controller; let generation = 0;
      const close = () => {panel.hidden = true; input.setAttribute('aria-expanded','false');};
      input.addEventListener('input', () => {
        clearTimeout(timer); controller?.abort(); const request = ++generation;
        const q = input.value.trim(); if (q.length < 2) {close(); return;}
        timer = setTimeout(async () => {
          controller = new AbortController();
          try {
            const params = new URLSearchParams({q,'resources[type]':'product','resources[limit]':'5','resources[options][unavailable_products]':'last'});
            const response = await fetch(root + 'search/suggest.json?' + params, {signal:controller.signal});
            if (!response.ok) throw new Error('Search unavailable');
            const result = await response.json(); if (request !== generation) return;
            const products = result.resources?.results?.products || [];
            panel.replaceChildren();
            for (const item of products) {
              const a = document.createElement('a'); a.href = item.url; a.textContent = item.title; panel.append(a);
            }
            const all = document.createElement('a'); all.href = root + 'search?' + new URLSearchParams({q,type:'product'}); all.textContent = products.length ? 'See all search results →' : 'Search the full catalog →'; panel.append(all);
            panel.hidden = false; input.setAttribute('aria-expanded','true');
          } catch (error) {if (error.name !== 'AbortError') close();}
        }, 250);
      });
      form.addEventListener('keydown', event => {
        const links = [...panel.querySelectorAll('a')];
        if (event.key === 'Escape') {close(); input.focus();}
        if (event.key === 'ArrowDown' && !panel.hidden) {event.preventDefault(); const index=links.indexOf(document.activeElement); links[Math.min(index+1,links.length-1)]?.focus();}
        if (event.key === 'ArrowUp' && !panel.hidden) {event.preventDefault(); const index=links.indexOf(document.activeElement); if(index<=0)input.focus();else links[index-1].focus();}
      });
      document.addEventListener('click', event => {if (!form.contains(event.target)) close();});
    });

    scope.querySelectorAll('[data-knife-finder]').forEach(finder => {
      if (finder.dataset.ready) return; finder.dataset.ready='true';
      const catalog=JSON.parse(finder.querySelector('[data-finder-products]').textContent);
      const steps=[...finder.querySelectorAll('[data-finder-step]')];
      const result=finder.querySelector('[data-finder-results]');
      const progress=finder.querySelector('[data-finder-progress]'); let step=0;
      const show=()=>{steps.forEach((el,i)=>{el.hidden=i!==step;});result.hidden=true;progress.textContent=`Step ${step+1} of 3`;steps[step].querySelector('legend')?.focus();};
      const answer=(name)=>finder.querySelector(`[name="${name}"]:checked`)?.value;
      finder.addEventListener('click',event=>{
        const next=event.target.closest('[data-finder-next]'); const back=event.target.closest('[data-finder-back]'); const restart=event.target.closest('[data-finder-restart]');
        if(restart){step=0;finder.querySelectorAll('input[type=radio]').forEach(el=>el.checked=false);show();return;}
        if(back){step=Math.max(0,step-1);show();return;}
        if(!next)return;
        const selected=steps[step].querySelector('input:checked');const error=steps[step].querySelector('[data-finder-error]');
        if(!selected){error.textContent='Choose an option to continue.';steps[step].querySelector('input')?.focus();return;}
        error.textContent=''; if(step<2){step++;show();return;}
        const use=answer('finder-use'),storage=answer('finder-storage'),budget=answer('finder-budget');
        const max=budget==='any'?Infinity:Number(budget);
        const products=catalog.filter(p=>p.available&&p.price<=max&&(use==='any'||p.use===use)&&(storage==='any'||p.storage===storage)).slice(0,3);
        steps.forEach(el=>el.hidden=true);result.hidden=false;progress.textContent='Your recommendations';
        const grid=result.querySelector('[data-finder-cards]');grid.replaceChildren();
        result.querySelector('[data-finder-empty]').hidden=products.length>0;
        for(const p of products){
          const card=document.createElement('article');card.className='syk-card';const link=document.createElement('a');link.className='syk-card-media';link.href=p.url;
          const img=document.createElement('img');img.src=p.image;img.alt=p.title;img.width=600;img.height=600;img.loading='lazy';link.append(img);card.append(link);
          const heading=document.createElement('h3');heading.textContent=p.title;card.append(heading);
          const price=document.createElement('p');price.textContent=p.priceText;card.append(price);
          const reason=document.createElement('p');reason.className='syk-card-use';reason.textContent=p.reason;card.append(reason);
          const cta=document.createElement('a');cta.className='syk-button';cta.href=p.url;cta.textContent='Explore this knife';card.append(cta);grid.append(card);
        }
        result.querySelector('h2')?.focus();
        publishFinder({use,storage,budget,result_count:products.length});
      });
    });
  }
  function publishFinder(data) {
    const privacy=window.Shopify?.customerPrivacy;
    if(privacy?.analyticsProcessingAllowed?.()!==true)return;
    window.Shopify?.analytics?.publish?.('syokami_knife_finder',data);
  }
  initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
